import { render, staticRenderFns } from "./savings.vue?vue&type=template&id=22fef01e&scoped=true"
import script from "./savings.vue?vue&type=script&lang=js"
export * from "./savings.vue?vue&type=script&lang=js"
import style0 from "./savings.vue?vue&type=style&index=0&id=22fef01e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fef01e",
  null
  
)

export default component.exports